import {
  BUILDING_META,
  LOOT,
  levelsUnderCap,
  sprintPaused,
  sprintRemainingMs,
  type BuildingId,
} from "@engine";
import type { Session } from "../state.ts";
import { $, formatClock, hide, show } from "./dom.ts";

const RING_LENGTH = 2 * Math.PI * 84;

/** Short display name used on the sprint screen. */
const SHORT: Record<BuildingId, string> = {
  townHall: "Keep",
  barracks: "Barracks",
  goldMine: "Gold Mine",
  crystalTankRevenue: "Revenue tank",
  crystalTankViralz: "Viralz tank",
  crystalTankTikwave: "Tikwave tank",
  crystalTankGoGrow: "GoGrow tank",
  crystalTankRihla: "Rihla tank",
  lab: "Lab",
  workshop: "Workshop",
  watchtower: "Watchtower",
  walls: "Walls",
  builderHut: "Builder Hut",
};

/** What actually levels the target, said plainly. */
const LEVELS_WHEN: Record<BuildingId, string> = {
  townHall: "levels up when you hit real plan milestones",
  barracks: "levels up when you send real applications",
  goldMine: "levels up when your real side income grows",
  crystalTankRevenue: "levels up when Revenue's real MRR grows",
  crystalTankViralz: "levels up when Viralz's real MRR grows",
  crystalTankTikwave: "levels up when Tikwave's real MRR grows",
  crystalTankGoGrow: "levels up when GoGrow's real MRR grows",
  crystalTankRihla: "levels up when Rihla's real MRR grows",
  lab: "levels up when you finish real lessons",
  workshop: "levels up when you ship real milestones",
  watchtower: "levels up when you post and grow real followers",
  walls: "get stronger when you fix real bugs",
  builderHut: "levels up when you do your real daily actions",
};

export function renderSprint(session: Session, now: number): void {
  const sprint = session.result.state.sprint;
  if (!sprint || sprint.completed) {
    hide($("sprint-modal"));
    return;
  }
  const id = sprint.buildingId;
  const name = SHORT[id];
  const remaining = sprintRemainingMs(sprint, now);
  const elapsed = sprint.durationMs > 0 ? 1 - remaining / sprint.durationMs : 1;
  const paused = sprintPaused(sprint);
  const under = levelsUnderCap(id, session.result.state.levels);

  $("sprint-target").textContent = `Target: ${name}`;
  $("sprint-bot").textContent = BUILDING_META[id].bot.replace(/ \(.*\)$/, "");
  $("sprint-timer").textContent = formatClock(remaining);
  $("sprint-sub").textContent = paused
    ? "paused"
    : `left of ${Math.round(sprint.durationMs / 60_000) || 1} min`;
  $("sprint-gold").textContent = `+${LOOT.sprintGold}`;
  $("sprint-crystals").textContent = `+${LOOT.sprintCrystals}`;
  $("sprint-cap").textContent =
    under > 0 ? `${name} is ${under} level${under === 1 ? "" : "s"} under cap` : `${name} is at the cap`;
  $("sprint-note").textContent = `Sprints pay loot only. The ${name} ${LEVELS_WHEN[id]}.`;
  $("sprint-pause").textContent = paused ? "Resume" : "Pause";
  $("sprint-ring").setAttribute(
    "stroke-dasharray",
    `${(RING_LENGTH * Math.max(0, Math.min(1, elapsed))).toFixed(1)} ${RING_LENGTH.toFixed(1)}`,
  );
  $("sprint-modal").classList.toggle("paused", paused);
  show($("sprint-modal"));
}

export function closeSprintModal(): void {
  hide($("sprint-modal"));
}
